import React from 'react';

const Category = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M13.765 9.585S15 10.554 15 12v5.5a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V12c0-1.446 1.235-2.415 1.235-2.415.6-.502.578-1.061.578-1.061V5h2.374v3.524s-.021.559.578 1.061Z"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="m2.551 5.675 1.836 12.237c.217 1.45.326 2.176.68 2.72a3 3 0 0 0 1.275 1.1C6.934 22 7.667 22 9.134 22h5.732c1.467 0 2.2 0 2.792-.269a3.001 3.001 0 0 0 1.275-1.098c.354-.545.463-1.27.68-2.721L21.45 5.675c.19-1.267.285-1.9.095-2.393a2 2 0 0 0-.88-1.022c-.459-.26-1.1-.26-2.38-.26H5.716c-1.28 0-1.921 0-2.38.26a2 2 0 0 0-.88 1.022c-.19.493-.095 1.126.095 2.393Z"
    />
  </svg>
);

export default Category;
